import Vue from 'vue';

const I18nMixin = Vue.extend({
    computed: {
        i18nPrefix() {
            throw new Error(`Must override computed property 'i18nPrefix()'`);
        }
    },
    methods: {
        i18nCommon(key: string) {
            return this.$i18n.t(`common.${key}`);
        },
        i18nLocal(key: string) {
            return this.$i18n.t(`${this.i18nPrefix}.${key}`);
        }
    }
});

export default I18nMixin;
